module.exports = __webpack_public_path__ + "img/P150T_weapon_99.daf9e9cd.png";